import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M13.5 15q-.618 0-1.059-.44A1.45 1.45 0 0 1 12 13.5v-2.25q0-.618.441-1.059T13.5 9.75q.619 0 1.06.441.44.441.44 1.059v2.25q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44M9 15q-.618 0-1.059-.44A1.45 1.45 0 0 1 7.5 13.5v-9q0-.618.441-1.059T9 3t1.06.441q.44.441.44 1.059v9q0 .619-.44 1.06A1.44 1.44 0 0 1 9 15m-4.5 0q-.618 0-1.059-.44A1.45 1.45 0 0 1 3 13.5V8.25q0-.619.441-1.059T4.5 6.75t1.06.441Q6 7.632 6 8.25v5.25q0 .619-.44 1.06A1.44 1.44 0 0 1 4.5 15"
    }, null, -1)
  ]))]))
}
export default { render: render }